import { useEffect, useState } from 'react'
import { AspenRequestsService, PaginatedDTO_RequestDTO_ } from '../client'
import { CancelablePromise } from '../client/core/CancelablePromise'

export const usePatientRequests = (patientId?: string) => {
    const [requests, setRequests] = useState<PaginatedDTO_RequestDTO_ | null>(null)
    const [loading, setLoading] = useState<boolean>(true)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        let isMounted = true

        const fetchOrders = async () => {
            setLoading(true)
            setError(null)
            try {
                const response: CancelablePromise<PaginatedDTO_RequestDTO_> = AspenRequestsService.indexRequestsGet({ patientId })
                const data = await response
                if (isMounted) {
                    setRequests(data)
                }
            } catch (err) {
                if (isMounted) {
                    setError('Failed to fetch orders data')
                }
            } finally {
                if (isMounted) {
                    setLoading(false)
                }
            }
        }

        fetchOrders()

        return () => {
            isMounted = false
        }
    }, [patientId])

    return { requests, loading, error }
}
